import { create } from 'zustand'

const useBannerStore = create((set) => ({
  topBannerHeight: 0,
  setTopBannerHeight: (height) => set({ topBannerHeight: height }),
}))

export default useBannerStore
